const azureClientId = (import.meta.env.VITE_AZURE_CLIENT_ID || '').trim()
const azureTenantId = (import.meta.env.VITE_AZURE_TENANT_ID || '').trim()

export const isAzureAuthConfigured = Boolean(azureClientId && azureTenantId)
export const isDevAuthBypass = import.meta.env.DEV && !isAzureAuthConfigured
export const isAzureAuthEnabled = !isDevAuthBypass

export const authConfig = {
  azureClientId,
  azureTenantId,
  redirectUri: import.meta.env.VITE_REDIRECT_URI || window.location.origin,
}

export const devSessionAccount = {
  name: 'Edward Buttacavoli',
  username: 'edward@helios-fintech.com',
}
